import React from "react";
import Grid from "./Grid";
import trainingImage from "../../images/trainingImage.svg";
import licensingImage from "../../images/licensingImage.svg";
import consultingImage from "../../images/consultancyIcon.svg";
import peopleImage from "../../images/peopleIcon.svg";
import processImage from "../../images/processIcon.svg";
import technologyImage from "../../images/technologyIcon.svg";
import industriesImage from "../../images/industrySolutionsImage.svg";
import assessmentIcon from "../../images/assessmentIcon.svg";
import cloudMigrationIcon from "../../images/cloudMigrationIcon.svg";
import enablementIcon from "../../images/enablementIcon.svg";
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
import { Bars } from "./Charts";
import { Parallax } from 'react-scroll-parallax';
import dataschoolIntroImage from "../../images/dataschoolIntro.png";

function WhatWeOfferGraphic() {
       return ( 
        <div className="grid max-w-full -sm:overflow-hidden h-[500px]">
            <div style={{ gridArea: '1/1'}} className="pl-0 lg:pl-[50px]"><Grid colour="blue" /></div>
            <Parallax speed={-5} style={{ gridArea: '1/1'}}>
                <svg width="400" height="400" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg"
                    className="ml-7 mt-12 lg:mt-0 lg:ml-0 w-[160px] h-[160px] lg:w-[280px] lg:h-[400px]"
                >
                    <circle cx="200" cy="200" r="200" fill="#FDB887"/>
                </svg>
            </Parallax>
            <Parallax speed={2} style={{ gridArea: '1/1'}} className="grid mx-auto lg:mx-0 mt-36 lg:mt-20 h-[185px] w-[330px] lg:h-[320px] lg:w-[450px]">
                <StaticImage
                    style={{ gridArea: '1/1', borderRadius: 10}}
                    loading="eager"
                    alt=""
                    src="../../images/london.png"
                    formats={["auto", "webp"]}
                />
                <div
                    style={{
                    gridArea: "1/1",
                    position: "relative",
                    placeItems: "center",
                    display: "grid",
                    backgroundColor: "#205E92",
                    mixBlendMode: 'hard-light',
                    borderRadius: 10
                    }}>
            </div>
          </Parallax>
          <Parallax speed={-2} style={{ gridArea: '1/1'}} className="grid mt-[280px] ml-[280px] lg:ml-12 h-[160px] w-[160px] lg:h-[320px] lg:w-[320px]">
                <div
                    style={{
                    gridArea: "1/1",
                    position: "relative",
                    placeItems: "center",
                    display: "grid",
                    backgroundColor: "#E48D4E",
                    mixBlendMode: 'color',
                    borderRadius: 320
                    }}>
                </div>
                <StaticImage
                    style={{ gridArea: '1/1', borderRadius: 320}}
                    loading="eager"
                    alt=""
                    src="../../images/execSalesDashboard.jpg"
                    formats={["auto", "webp"]}
                />
            </Parallax>
            <div style={{gridArea: '1/1'}} className="mt-[420px] ml-[380px] lg:mt-[360px] lg:ml-[280px] z-10">
                <svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160" fill="none"
                    className="w-[40px] h-[40px] lg:w-[160px] lg:h-[160px] "
                >
                    <circle cx="80" cy="80" r="79.25" stroke="#3797D3" strokeWidth="1.5"/>
                </svg>
            </div>  
        </div>
    )
} 

function DataSchoolGraphic() {
    return (
        <div className="grid max-w-lg lg:max-w-full -sm:overflow-hidden h-[500px]">
            <div style={{ gridArea: '1/1'}} className="lg:mt-[50px] xl:-ml-[230px]"><Grid colour={"orange"}/></div>
            <div style={{ gridArea: '1/1'}} className="mt-16 ml-8 lg:mt-[70px] lg:-ml-[50px] xl:-ml-[170px]">
                <svg width="360" height="360" viewBox="0 0 360 360" fill="none" xmlns="http://www.w3.org/2000/svg"
                    className="w-[160px] h-[160px] lg:w-[360px] lg:h-[360px]"
                >
                    <circle cx="180" cy="180" r="180" fill="#60B7ED"/>
                </svg>
            </div>
            <div style={{gridArea: '1/1'}} className="mt-24 lg:mt-6 ml-[240px] md:right-40 lg:ml-[270px] z-10">
                <svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160" fill="none"
                    className="w-[80px] h-[80px] lg:w-[160px] lg:h-[160px]"
                >
                    <circle cx="80" cy="80" r="79.25" stroke="#3797D3" strokeWidth="1.5"/>
                </svg>
            </div>
            <div style={{ gridArea: '1/1'}} className="grid mt-[340px] lg:mt-[280px] ml-[180px] lg:ml-28 h-[160px] w-[160px] lg:h-[320px] lg:w-[320px]">
                <StaticImage
                    style={{ gridArea: '1/1', borderRadius: 320}}
                    loading="eager"
                    alt=""
                    src="../../images/solarpanels.png"
                    formats={["auto", "webp"]}
                />
            </div>
            <Parallax speed={-4} style={{ gridArea: '1/1'}} className="grid mt-32 lg:-ml-8 mx-auto lg:mx-0 h-[215px] w-[320px] sm:h-[250px] sm:w-[360px] lg:h-[280px] lg:w-[380px] xl:-ml-16 xl:h-[340px] xl:w-[460px]">
                <div
                    style={{ gridArea: '1/1', borderRadius: 10,  background: `url(${dataschoolIntroImage}) 50% 50% no-repeat`, backgroundSize: 'cover', backgroundColor: 'white'}}
                    className="shadow-xl"
                    alt=""
                />
                <div
                    style={{
                    gridArea: "1/1",
                    position: "relative",
                    placeItems: "center",
                    display: "grid",
                    backgroundColor: "#FFF5EE",
                    mixBlendMode: 'hue',
                    borderRadius: 10,
                    }}>
            </div>
          </Parallax>
          <div style={{gridArea: '1/1'}} className="mt-[370px] lg:mt-[430px] ml-20 lg:-ml-8 z-10">
            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none"
                className="h-[40px] w-[40px] lg:h-[80px] lg:w-[80px]"
            >
            <g filter="url(#filter0_d_401_641)">
                <circle cx="40" cy="40" r="40" fill="white"/>
            </g>
            </svg>
          </div>
        </div>
    )
}

function TrainingPageGraphic() {
    return ( 
     <div className="grid max-w-full -sm:overflow-hidden h-[500px]">
         <div style={{ gridArea: '1/1'}} className=""><Grid colour={"orange"}/></div>
         <Parallax speed={5} style={{ gridArea: '1/1'}}>
             <svg width="240" height="240" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg"
                 className=" ml-4 lg:-ml-16 mt-8 w-[160px] h-[160px] lg:w-[240px] lg:h-[240px]"
             >
                 <circle cx="120" cy="120" r="120" fill="#AEBCE2"/>
             </svg>
         </Parallax>
       <Parallax speed={-10} style={{ gridArea: '1/1'}} className="grid mt-[100px] lg:mt-[30px] ml-[0px]">
             <img
                 style={{ gridArea: '1/1'}}
                 className="ml-16 lg:ml-20 h-[320px] w-[320px] lg:h-[380px] lg:w-[360px]"
                 alt=""
                 src={trainingImage}
             />
         </Parallax>
         <Parallax speed={-5} style={{gridArea: '1/1'}} className="mt-[340px] ml-[260px] z-10">
             <svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160" fill="none"
                 className="w-[120px] h-[120px] lg:w-[160px] lg:h-[160px] "
             >
                 <circle cx="80" cy="80" r="79.25" stroke="#E48D4E" strokeWidth="1.5"/>
             </svg>
         </Parallax>  
     </div>
 )
} 

function LicensingPageGraphic() {
    return ( 
     <div className="grid max-w-full -sm:overflow-hidden h-[500px]">
         <div style={{ gridArea: '1/1'}} className=""><Grid colour={"blue"}/></div>
         <Parallax speed={5} style={{ gridArea: '1/1'}}>
             <svg width="240" height="240" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg"
                 className="ml-4 lg:-ml-16 mt-8 w-[160px] h-[160px] lg:w-[240px] lg:h-[240px]"
             >
                 <circle cx="120" cy="120" r="120" fill="#AEBCE2"/>
             </svg>
         </Parallax>
       <Parallax speed={-10} style={{ gridArea: '1/1'}} className="grid mt-[100px] lg:mt-[30px] ml-[0px]">
             <img
                 style={{ gridArea: '1/1'}}
                 className="ml-16 lg:ml-20 h-[280px] w-[280px] lg:h-[380px] lg:w-[360px]"
                 alt=""
                 src={licensingImage}
             />
         </Parallax>
         <Parallax speed={-5} style={{gridArea: '1/1'}} className="mt-[340px] ml-[260px] z-10">
             <svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160" fill="none"
                 className="w-[120px] h-[120px] lg:w-[160px] lg:h-[160px] "
             >
                 <circle cx="80" cy="80" r="79.25" stroke="#E48D4E" strokeWidth="1.5"/>
             </svg>
         </Parallax>  
     </div>
 )
} 

function IndustriesPageGraphic() {
    return ( 
     <div className="grid max-w-full -sm:overflow-hidden h-[500px]">
         <div style={{ gridArea: '1/1'}} className=""><Grid colour={"blue"}/></div>
         <Parallax speed={5} style={{ gridArea: '1/1'}}>
             <svg width="240" height="240" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg"
                 className="-ml-16 mt-8 w-[160px] h-[160px] lg:w-[240px] lg:h-[240px]"
             >
                 <circle cx="120" cy="120" r="120" fill="#AEBCE2"/>
             </svg>
         </Parallax>
       <Parallax speed={-10} style={{ gridArea: '1/1'}} className="grid mt-[30px] ml-[0px]">
             <img
                 style={{ gridArea: '1/1'}}
                 className="ml-16 lg:ml-20 h-[280px] w-[280px] lg:h-[380px] lg:w-[360px]"
                 alt=""
                 src={industriesImage}
             />
         </Parallax>
         <Parallax speed={-5} style={{gridArea: '1/1'}} className="mt-[340px] ml-[260px] z-10">
             <svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160" fill="none"
                 className="w-[120px] h-[120px] lg:w-[160px] lg:h-[160px] "
             >
                 <circle cx="80" cy="80" r="79.25" stroke="#E48D4E" strokeWidth="1.5"/>
             </svg>
         </Parallax>  
     </div>
 )
} 

function ConsultingPageGraphic() {
    return ( 
     <div className="grid max-w-full -sm:overflow-hidden h-[500px]">
         <div style={{ gridArea: '1/1'}} className=""><Grid colour={"blue"}/></div>
         <Parallax speed={5} style={{ gridArea: '1/1'}}>
             <svg width="240" height="240" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg"
                 className="-ml-16 mt-8 w-[160px] h-[160px] lg:w-[240px] lg:h-[240px]"
             >
                 <circle cx="120" cy="120" r="120" className=" fill-moon-700"/>
             </svg>
         </Parallax>
       <Parallax speed={-10} style={{ gridArea: '1/1'}} className="grid mt-[70px] ml-[30px]">
             <img
                 style={{ gridArea: '1/1'}}
                 className="ml-16 lg:ml-20 h-[280px] w-[280px] lg:h-[380px] lg:w-[360px]"
                 alt=""
                 src={consultingImage}
             />
         </Parallax>
         <Parallax speed={-5} style={{gridArea: '1/1'}} className="mt-[340px] ml-[260px] z-10">
             <svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160" fill="none"
                 className="w-[120px] h-[120px] lg:w-[160px] lg:h-[160px] "
             >
                 <circle cx="80" cy="80" r="79.25" stroke="#E48D4E" strokeWidth="1.5"/>
             </svg>
         </Parallax>  
     </div>
 )
}

function PeoplePageGraphic() {
    return ( 
     <div className="grid max-w-full -sm:overflow-hidden h-[500px]">
         <div style={{ gridArea: '1/1'}} className=""><Grid colour={"blue"}/></div>
         <Parallax speed={5} style={{ gridArea: '1/1'}}>
             <svg width="240" height="240" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg"
                 className="-ml-16 mt-8 w-[160px] h-[160px] lg:w-[240px] lg:h-[240px]"
             >
                 <circle cx="120" cy="120" r="120" className=" fill-moon-700"/>
             </svg>
         </Parallax>
       <Parallax speed={-10} style={{ gridArea: '1/1'}} className="grid mt-[70px] ml-[30px]">
             <img
                 style={{ gridArea: '1/1'}}
                 className="h-[180px] w-[180px] lg:h-[380px] lg:w-[360px]"
                 alt=""
                 src={peopleImage}
             />
         </Parallax>
         <Parallax speed={-5} style={{gridArea: '1/1'}} className="mt-[340px] ml-[260px] z-10">
             <svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160" fill="none"
                 className="w-[120px] h-[120px] lg:w-[160px] lg:h-[160px] "
             >
                 <circle cx="80" cy="80" r="79.25" stroke="#E48D4E" strokeWidth="1.5"/>
             </svg>
         </Parallax>  
     </div>
 )
} 

function TechnologyPageGraphic() {
    return ( 
     <div className="grid max-w-full -sm:overflow-hidden h-[500px]">
         <div style={{ gridArea: '1/1'}} className=""><Grid colour={"blue"}/></div>
         <Parallax speed={5} style={{ gridArea: '1/1'}}>
             <svg width="240" height="240" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg"
                 className=" ml-4 lg:-ml-16 mt-8 w-[160px] h-[160px] lg:w-[240px] lg:h-[240px]"
             >
                 <circle cx="120" cy="120" r="120" className=" fill-moon-700"/>
             </svg>
         </Parallax>
       <Parallax speed={-10} style={{ gridArea: '1/1'}} className="grid mt-[70px] ml-[30px]">
             <img
                 style={{ gridArea: '1/1'}}
                 className="ml-16 lg:ml-20 h-[280px] w-[280px] lg:h-[380px] lg:w-[360px]"
                 alt=""
                 src={technologyImage}
             />
         </Parallax>
         <Parallax speed={-5} style={{gridArea: '1/1'}} className="mt-[340px] ml-[260px] z-10">
             <svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160" fill="none"
                 className="w-[120px] h-[120px] lg:w-[160px] lg:h-[160px] "
             >
                 <circle cx="80" cy="80" r="79.25" stroke="#E48D4E" strokeWidth="1.5"/>
             </svg>
         </Parallax>  
     </div>
 )
}

function ProcessPageGraphic() {
    return ( 
     <div className="grid max-w-full -sm:overflow-hidden h-[500px]">
         <div style={{ gridArea: '1/1'}} className=""><Grid colour={"blue"}/></div>
         <Parallax speed={5} style={{ gridArea: '1/1'}}>
             <svg width="240" height="240" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg"
                 className=" ml-4 lg:-ml-16 mt-8 w-[160px] h-[160px] lg:w-[240px] lg:h-[240px]"
             >
                 <circle cx="120" cy="120" r="120" className=" fill-moon-700"/>
             </svg>
         </Parallax>
       <Parallax speed={-10} style={{ gridArea: '1/1'}} className="grid mt-[70px] ml-[30px]">
             <img
                 style={{ gridArea: '1/1'}}
                 className="ml-16 lg:ml-20 h-[280px] w-[280px] lg:h-[380px] lg:w-[360px]"
                 alt=""
                 src={processImage}
             />
         </Parallax>
         <Parallax speed={-5} style={{gridArea: '1/1'}} className="mt-[340px] ml-[260px] z-10">
             <svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160" fill="none"
                 className="w-[120px] h-[120px] lg:w-[160px] lg:h-[160px] "
             >
                 <circle cx="80" cy="80" r="79.25" stroke="#E48D4E" strokeWidth="1.5"/>
             </svg>
         </Parallax>  
     </div>
 )
} 

function GetChart(chart, colour) {
    // console.log('[Block.js] chart', chart);
    if (chart === "bars") {
        return (<Bars colour={colour || 'orange'} />)
    }
    return (null)
}

function PageIntroGraphic({chart, chartColour, image, gatsbyImage, tint, imageLogo, imageFullSize, tintOverlay}) {
    
    return ( 
     <div className="grid max-w-full -sm:overflow-hidden h-[500px]">
         <div style={{ gridArea: '1/1'}} className=""><Grid colour={tint}/></div>
         <Parallax speed={5} style={{ gridArea: '1/1'}}>
             {chart ? 
                GetChart(chart, chartColour)
             : <svg width="240" height="240" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg"
                 className="ml-12 lg:-ml-7 mt-8 w-[200px] h-[200px] lg:w-[240px] lg:h-[240px]"
             >
                 <circle cx="120" cy="120" r="120" className={`fill-${tint ? tint : "orange"}-500 `}/>
             </svg>}
         </Parallax>
       {imageLogo? 
        <Parallax speed={-5} style={{ gridArea: '1/1'}} className="grid mt-[80px] ml-[90px] h-[180px] w-[180px] lg:h-[360px] lg:w-[360px]">
            <div
                style={{ gridArea: '1/1', borderRadius: 330}}
                className={`bg-white flex align-middle border-${tint}-100 border-8 shadow-2xl`}
            >
                <img  
                    alt=""
                    src={image}
                    className="mx-auto my-auto align-middle max-h-[180px]"
                />
            </div>
        </Parallax>
        : imageFullSize ?
        <Parallax speed={-5} style={{ gridArea: '1/1'}} className="grid mt-[80px] ml-[90px] max-h-[360px] ">
            <div
                style={{ gridArea: '1/1'}}
                className={`flex align-middle`}
            >
                <img  
                    alt=""
                    src={image}
                    className="mx-auto my-auto align-middle max-h-[360px]"
                />
            </div>
        </Parallax>
       : 
       <Parallax speed={-5} style={{ gridArea: '1/1'}} className="grid mt-[80px] ml-[90px] h-[260px] w-[260px] lg:h-[360px] lg:w-[360px]">
             {gatsbyImage ? 
                <GatsbyImage
                    image={gatsbyImage}
                    style={{ gridArea: '1/1', borderRadius: 360 }}
                    alt=""
                    className="shadow-2xl bg-cover bg-center"
                />
             : <div
                 style={{ gridArea: '1/1', borderRadius: 360, background: `url(${image}) 50% 50% no-repeat`, backgroundSize: 'cover', backgroundColor: 'white' }}
                 alt=""
                 className="shadow-2xl bg-white"
             />}
             {tintOverlay ? <div
                 style={{
                 gridArea: "1/1",
                 position: "relative",
                 placeItems: "center",
                 display: "grid",
                 mixBlendMode: tintOverlay,
                 borderRadius: 330
                 }}
                 className={`bg-${tint}-700`}>
             </div> : null}
         </Parallax>}
         <Parallax speed={10} style={{gridArea: '1/1'}} className="mt-[280px] ml-[240px] lg:mt-[370px] lg:ml-[300px] z-10">
             <svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160" fill="none"
                 className="w-[160px] h-[160px] "
             >
                 <circle cx="80" cy="80" r="79.25" strokeWidth="1.5" className={`stroke-${tint ? tint : "blue"}-700 `}/>
             </svg>
         </Parallax>  
     </div>
 )
}

function PageTextBlockGraphic({image, tint, imageLogo, image2, noTint, alternate}) {
    
    return ( 
     <div className="grid max-w-full">
         {alternate ? 
            <>
            <Parallax speed={5} style={{ gridArea: '1/1'}}>
                <svg width="240" height="240" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg"
                    className="ml-6 lg:-ml-7 lg:mt-20 w-[160px] h-[160px] lg:w-[240px] lg:h-[240px]"
                >
                    <circle cx="120" cy="120" r="120" className={`fill-moon-500 stroke-[1px]`}/>
                </svg>
            </Parallax>
            <Parallax speed={2} style={{ gridArea: '1/1'}}>
                <svg width="100" height="100" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg"
                    className="ml-32 lg:ml-20 -mt-4 lg:mt-8 w-[60px] h-[60px] lg:w-[100px] lg:h-[100px]"
                >
                    <circle cx="110" cy="110" r="110" className={`stroke-orange-500 stroke-[3px]`}/>
                </svg>
            </Parallax>
            </>
            :
            <Parallax speed={-8} style={{ gridArea: '1/1'}}>
                <svg width="240" height="240" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg"
                    className="ml-6 lg:-ml-7 -mt-8 lg:mt-8 w-[160px] h-[160px] lg:w-[240px] lg:h-[240px]"
                >
                    <circle cx="120" cy="120" r="120" className={`fill-orange-500 `}/>
                </svg>
            </Parallax>
         }
       {imageLogo? 
        <Parallax speed={-5} style={{ gridArea: '1/1'}} className="grid mt-[30px] lg:mt-[80px] ml-[100px] lg:ml-[90px] h-[280px] w-[280px] lg:h-[360px] lg:w-[360px]">
            <div
                style={{ gridArea: '1/1', borderRadius: 330}}
                className={`bg-white flex align-middle border-${tint}-100 border-8 shadow-2xl`}
            >
                <img  
                    alt=""
                    src={image}
                    className="mx-auto my-auto align-middle max-h-[120px] lg:max-h-[180px]"
                />
            </div>
        </Parallax>
       : !image2 ?
       <Parallax speed={-5} style={{ gridArea: '1/1'}} className={`grid mt-[30px] lg:mt-[80px] ${alternate ? 'ml-[80px]' : 'ml-[100px]'} lg:ml-[90px] h-[280px] w-[280px] lg:h-[360px] lg:w-[360px]`}>
             <div
                 style={{ gridArea: '1/1', borderRadius: 330, background: `url(${image}) 50% 50% no-repeat`, backgroundSize: 'cover', backgroundColor: 'white'}}
                 alt=""
                 className={`shadow-2xl object-cover`}
             />
             {!noTint ? <div
                 style={{
                 gridArea: "1/1",
                 position: "relative",
                 placeItems: "center",
                 display: "grid",
                 mixBlendMode: 'color',
                 borderRadius: 330
                 }}
                 className={`bg-${tint}-700`}>
             </div> : null}
         </Parallax>
         :
         <>
            <div style={{ gridArea: '1/1'}} 
                className="grid 
                            mt-[220px] lg:mt-[200px]
                            ml-[240px] md:ml-[180px] lg:ml-[140px] xl:ml-[140px]
                            h-[160px] w-[160px] lg:h-[320px] lg:w-[320px]">
                    <div
                        style={{ gridArea: '1/1', borderRadius: 320, background: `url(${image}) 50% 50% no-repeat`, backgroundSize: 'cover', backgroundColor: 'white'}}
                        alt=""
                        className={`shadow-2xl object-cover`}
                    />
                </div>
                <Parallax speed={-4} style={{ gridArea: '1/1'}} 
                    className="grid 
                                mt-12 lg:mt-20 xl:mt-16 
                                mx-auto lg:mx-0 lg:ml-4 xl:ml-0 
                                h-[215px] w-[320px] sm:h-[250px] sm:w-[360px] lg:h-[280px] lg:w-[380px] xl:h-[300px] xl:w-[420px]
                                ">
                    <div
                        style={{ gridArea: '1/1', borderRadius: 10, background: `url(${image2}) 50% 50% no-repeat`, backgroundSize: 'cover'}}
                        alt=""
                        className={`object-cover`}
                    />    
            </Parallax>
          </>
         }
         {alternate ?
            <Parallax speed={-10} style={{ gridArea: '1/1'}}>
                <svg width="50" height="50" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"
                    className={`${image && image2 ? 'ml-[80px] mt-[260px] lg:mt-[300px] ' : 'ml-[300px] lg:ml-[350px] mt-8 lg:mt-16 '}w-[30px] h-[30px] lg:w-[50px] lg:h-[50px]`}
                >
                    <circle cx="50" cy="50" r="50" className={`fill-blue-500`}/>
                </svg>
            </Parallax>
            :
            <Parallax speed={3} style={{ gridArea: '1/1'}}>
                <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"
                    className={`${image && image2 ? 'ml-[80px] mt-[260px] lg:mt-[300px] ' : 'ml-[300px] lg:ml-[350px] lg:mt-16 '}w-[60px] h-[60px] lg:w-[100px] lg:h-[100px]`}
                >
                    <circle cx="50" cy="50" r="50" className={`fill-plum-500`}/>
                </svg>
            </Parallax>
         }
         <div style={{gridArea: '1/1'}} className={`z-10 ${image && image2 ? '-mt-[40px] ml-[300px]' : `mt-[270px] lg:mt-[400px] ${alternate ? 'ml-[260px]' : 'ml-[300px]'}`}`} >
             <svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160" fill="none"
                 className="w-[80px] h-[80px] lg:w-[160px] lg:h-[160px]"
             >
                 <circle cx="80" cy="80" r="79.25" strokeWidth="1.5" className={`stroke-blue-700`}/>
             </svg>
         </div>
         {alternate ? 
            <Parallax speed={-8} style={{ gridArea: '1/1'}}>
                <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"
                    className={`mt-[260px] lg:mt-[360px] ml-[300px] lg:ml-[350px] w-[60px] h-[60px] lg:w-[100px] lg:h-[100px]`}
                >
                    <circle cx="50" cy="50" r="50" className={`fill-orange-500`}/>
                </svg>
         </Parallax>
         : null}
     </div>
 )
} 

function BasicGridWithBubble({tint}) {
    return (
        <div className="grid w-[80%] lg:w-[480px]">
         <div style={{ gridArea: '1/1'}} className=""><Grid colour={tint}/></div>
         <Parallax speed={8} style={{ gridArea: '1/1'}}>
            <svg xmlns="http://www.w3.org/2000/svg" className="ml-[281px] -mt-[39px]" width="160" height="160" viewBox="0 0 160 160" fill="none">
                <circle cx="80" cy="80" r="79.25" stroke="#AEBCE2" strokeWidth="1.5"/>
            </svg>
         </Parallax>
        </div>
    )
}

function BasicGridWithTwoBubbles({tint}) {
    return (
        <div className="grid w-[80%] lg:w-[480px]">
         <div style={{ gridArea: '1/1'}} className=""><Grid colour={tint}/></div>
         <Parallax speed={-6} style={{ gridArea: '1/1'}}>
            <svg xmlns="http://www.w3.org/2000/svg" className="mt-36 float-right mr-28" width="80" height="80" viewBox="0 0 80 80" fill="none">
                <circle cx="40" cy="40" r="40" fill="#AEBCE2"/>
            </svg>
         </Parallax>
         <Parallax speed={8} style={{ gridArea: '1/1'}}>
            <svg xmlns="http://www.w3.org/2000/svg" className="ml-[281px] -mt-[39px]" width="160" height="160" viewBox="0 0 160 160" fill="none">
                <circle cx="80" cy="80" r="79.25" stroke="#AEBCE2" strokeWidth="1.5"/>
            </svg>
         </Parallax>
        </div>
    )
}

function GridWithRadial({tint}) {
    return (
        <div className="grid w-[80%] lg:w-[480px]">
         <div style={{ gridArea: '1/1'}} className=""><Grid colour={tint}/></div>
         <Parallax speed={20} style={{ gridArea: '1/1'}}>
         <svg xmlns="http://www.w3.org/2000/svg" className="ml-[240px] -mt-[39px]" width="240" height="240" viewBox="0 0 240 240" fill="none">
            <g opacity="0.25">
                <path fillRule="evenodd" clipRule="evenodd" d="M235.385 120C235.385 183.725 183.725 235.385 120 235.385V240C186.274 240 240 186.274 240 120C240 53.7258 186.274 0 120 0C53.7258 0 0 53.7258 0 120H4.61538C4.61538 56.2748 56.2748 4.61538 120 4.61538C183.725 4.61538 235.385 56.2748 235.385 120Z" className={`fill-${tint}-500`}/>
                <path fillRule="evenodd" clipRule="evenodd" d="M146.532 222.812C192.32 211.03 226.154 169.466 226.154 120C226.154 61.3732 178.627 13.8465 120 13.8465C61.3728 13.8465 13.8462 61.3731 13.8461 120H9.23071C9.23078 58.8241 58.8238 9.23108 120 9.23108C181.176 9.23108 230.769 58.8242 230.769 120C230.769 171.617 195.464 214.987 147.685 227.282L146.532 222.812Z" className={`fill-${tint}-500`}/>
                <path fillRule="evenodd" clipRule="evenodd" d="M205.273 166.111C212.703 152.398 216.923 136.692 216.923 120C216.923 66.4707 173.529 23.0768 120 23.0768C66.4707 23.0768 23.0768 66.4707 23.0768 120C23.0768 120 23.0768 120 23.0768 120H18.4614C18.4614 120 18.4614 120 18.4614 120C18.4614 63.9217 63.9217 18.4614 120 18.4614C176.078 18.4614 221.538 63.9217 221.538 120C221.538 137.487 217.118 153.941 209.334 168.306L205.273 166.111Z" className={`fill-${tint}-500`}/>
                <path fillRule="evenodd" clipRule="evenodd" d="M135.464 177.989C161.107 171.168 180 147.79 180 120C180 86.8629 153.137 60 120 60C86.8631 60 60.0003 86.8628 60.0002 120H55.3848C55.3849 84.3138 84.3141 55.3846 120 55.3846C155.686 55.3846 184.616 84.3139 184.616 120C184.616 149.928 164.269 175.104 136.653 182.449L135.464 177.989Z" className={`fill-${tint}-500`}/>
                <path fillRule="evenodd" clipRule="evenodd" d="M198.461 120C198.461 163.333 163.333 198.462 120 198.462C94.189 198.462 71.2892 185.999 56.9897 166.762L53.2832 169.513C68.4238 189.881 92.6707 203.077 120 203.077C165.882 203.077 203.077 165.882 203.077 120C203.077 74.1179 165.882 36.9231 120 36.9231C74.1177 36.9231 36.9229 74.1179 36.9229 120H41.5382C41.5382 76.6669 76.6667 41.5385 120 41.5385C163.333 41.5385 198.461 76.6669 198.461 120Z" className={`fill-${tint}-500`}/>
                <path fillRule="evenodd" clipRule="evenodd" d="M188.664 174.55C200.575 159.577 207.692 140.62 207.692 120C207.692 71.5691 168.431 32.3079 120 32.3079C71.5687 32.3079 32.3075 71.5691 32.3075 120H27.6921C27.6921 69.0201 69.0197 27.6925 120 27.6925C170.98 27.6925 212.308 69.0201 212.308 120C212.308 141.705 204.816 161.66 192.278 177.421L188.664 174.55Z" className={`fill-${tint}-500`}/>
                <path fillRule="evenodd" clipRule="evenodd" d="M189.231 120C189.231 158.235 158.235 189.231 120 189.231C113.304 189.231 106.829 188.28 100.705 186.506L99.4186 190.94C105.951 192.832 112.857 193.846 120 193.846C160.784 193.846 193.846 160.784 193.846 120C193.846 79.2161 160.784 46.1541 120 46.1541C79.2159 46.1541 46.1538 79.2161 46.1538 120H50.7692C50.7692 81.7651 81.7649 50.7694 120 50.7694C158.235 50.7694 189.231 81.7651 189.231 120Z" className={`fill-${tint}-500`}/>
            </g>
            </svg>
         </Parallax>
        </div>
    )
}

function BlogPostAuthor({image}) {
    return (
        <div className="grid relative">
            <Parallax speed={1} style={{ gridArea: '1/1'}} className="absolute lg:top-6 right-32 lg:right-[280px] h-[160px] w-[160px]">
                <svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160" fill="none">
                    <circle cx="80" cy="80" r="80" className="fill-blue-300"/>
                </svg>
            </Parallax>
            <Parallax speed={5} style={{ gridArea: '1/1'}} className="grid ml-0 mt-[30px] lg:mt-[80px] h-[180px] w-[180px]">
                <div
                    style={{ 
                        gridArea: '1/1',
                        borderRadius: 180,
                        background: `${image ? `url(${image}) no-repeat,` : ''} #60B7ED`,
                        backgroundPosition: 'top 50%',
                        backgroundSize: '180px'
                    }}
                    className={`bg-orange-300 flex align-middle shadow-2xl`}
                >
                </div>
            </Parallax>
            <Parallax speed={-3} style={{ gridArea: '1/1'}} className="absolute bottom-0 right-52 lg:right-[350px] h-[40px] w-[40px]">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <circle cx="20" cy="20" r="20" className="fill-orange-500"/>
                </svg>
            </Parallax>
        </div>
    )
}

function EventFeatureImage({image}) {
    return (
        <div className="grid relative">
            <Parallax speed={1} style={{ gridArea: '1/1'}} className="absolute -top-6 -left-[20px] md:right-[280px] h-[160px] w-[160px]">
                <svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160" fill="none">
                    <circle cx="80" cy="80" r="80" className="fill-blue-300"/>
                </svg>
            </Parallax>
            <Parallax speed={5} style={{ gridArea: '1/1'}} className="grid 
                                mt-4 md:mt-12 lg:mt-20 xl:mt-16 
                                ml-4 lg:mx-0 lg:ml-4 xl:ml-0 
                                h-[215px] w-[320px] sm:h-[250px] sm:w-[360px] lg:h-[280px] lg:w-[380px] xl:h-[300px] xl:w-[420px]
                                ">
                    <div
                        style={{ gridArea: '1/1', borderRadius: 10, background: `url(${image}) 50% 50% no-repeat`, backgroundSize: 'cover'}}
                        alt=""
                        className={`object-cover`}
                    />  
            </Parallax>
            <Parallax speed={-3} style={{ gridArea: '1/1'}} className="absolute bottom-0 right-[150px] h-[40px] w-[40px]">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <circle cx="20" cy="20" r="20" className="fill-orange-500"/>
                </svg>
            </Parallax>
        </div>
    )
}


function AlumniPhoto({image}) {
    return (
        <div className="grid relative">
            <Parallax speed={1} style={{ gridArea: '1/1'}} className="ml-[140px] mt-[40px]">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-[200px] w-[200px] lg:h-[240px] lg:w-[240px]" viewBox="0 0 160 160" fill="none">
                    <circle cx="80" cy="80" r="80" className="fill-orange-500"/>
                </svg>
            </Parallax>
            <Parallax speed={5} style={{ gridArea: '1/1'}} className="grid mt-[80px] h-[240px] w-[240px] lg:h-[360px] lg:w-[360px]">
                <div
                    style={{ 
                        gridArea: '1/1',
                        borderRadius: 180,
                        background: `${image ? `url(${image}) no-repeat center center` : ''} #60B7ED`,
                        backgroundPosition: 'center',
                        backgroundSize: '360px 360px'
                    }}
                    className={`bg-orange-300 bg-cover flex align-middle shadow-2xl h-[240px] w-[240px] lg:h-[360px] lg:w-[360px]`}
                >
                </div>
            </Parallax>
            <Parallax speed={-3} style={{ gridArea: '1/1'}} className="absolute ml-[40px] bottom-4 h-[40px] w-[40px]">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <circle cx="20" cy="20" r="20" className="fill-blue-500"/>
                </svg>
            </Parallax>
        </div>
    )
}

function CloudMigrationProcess() {
    return (
        <div className="h-[750px] md:h-[480px] my-20 w-full">
            <div className="mx-auto xl:max-w-7xl">
                <h2 className="text-blue-700 font-title leading-tight text-[30px] lg:text-[45px] font-semibold mb-[30px] ml-12">Our cloud migration process</h2>
                <div className="mx-auto md:w-[760px] lg:w-[1060px]">
                    <div className="md:flex">
                    <Parallax speed={5} className="relative mx-auto md:mx-0 h-[280px] w-[280px] p-7 lg:h-[380px] lg:w-[380px] rounded-full bg-orange-900 shadow-xl">
                        <div className="w-full h-full flex align-middle items-center">
                            <div className="mx-auto content-center">
                                <div className="mx-auto h-[50px] w-[50px] lg:h-[80px] lg:w-[80px] mb-6">
                                    <img src={assessmentIcon} alt="" className="h-[50px] w-[50px] lg:h-[80px] lg:w-[80px]" />
                                </div>
                                <h2 className="font-title text-white font-semibold text-[25px] lg:text-[40px] leading-9 mb-2">
                                    Assessment
                                </h2>
                            </div>
                        </div>
                    </Parallax>
                    <Parallax speed={-5} className="relative mx-auto md:mx-0 h-[280px] w-[280px] -mt-20 md:mt-0 ml-20 md:-ml-10 p-7 lg:h-[380px] lg:w-[380px] rounded-full bg-plum-900 shadow-xl">
                        <div className="w-full h-full flex align-middle items-center">
                            <div className="mx-auto">
                                <div className="mx-auto h-[50px] w-[50px] lg:h-[80px] lg:w-[80px] mb-6">
                                    <img src={cloudMigrationIcon} alt="" className="h-[50px] w-[50px] lg:h-[80px] lg:w-[80px]" />
                                </div>
                                <h2 className="font-title text-white font-semibold text-[25px] lg:text-[40px] leading-9 mb-2">
                                    Migration
                                </h2>
                            </div>
                        </div>
                    </Parallax>
                    <Parallax speed={5} className="relativ mx-auto md:mx-0 h-[280px] w-[280px] -mt-20 md:mt-0 md:-ml-10 p-7 lg:h-[380px] lg:w-[380px] rounded-full bg-moon-900 shadow-xl">
                        <div className="w-full h-full flex align-middle items-center">
                            <div className="mx-auto content-center">
                                <div className="mx-auto h-[50px] w-[50px] lg:h-[80px] lg:w-[80px] mb-6">
                                    <img src={enablementIcon} alt="" className="h-[50px] w-[50px] lg:h-[80px] lg:w-[80px]" />
                                </div>
                                <h2 className="font-title text-white font-semibold text-[25px] lg:text-[40px] leading-9 mb-2">
                                    Enablement
                                </h2>
                            </div>
                        </div>
                    </Parallax>
                    </div>
                </div>
            </div>
        </div>
    )
}

export { 
    WhatWeOfferGraphic, 
    DataSchoolGraphic,
    TrainingPageGraphic, 
    LicensingPageGraphic,
    ConsultingPageGraphic,
    PeoplePageGraphic,
    ProcessPageGraphic,
    TechnologyPageGraphic,
    IndustriesPageGraphic,
    PageIntroGraphic,
    PageTextBlockGraphic,
    BasicGridWithBubble,
    BasicGridWithTwoBubbles,
    GridWithRadial,
    BlogPostAuthor,
    EventFeatureImage,
    AlumniPhoto,
    CloudMigrationProcess
}